module.exports = "/static/img/ai-background-hero-mobile.png?96d230e28b1659a7079156ba2d7747dd";